import { defineMessages } from 'react-intl';

const messages = defineMessages({
  supportHeader: {
    description: 'helpMenuDropdown.support',
    defaultMessage: 'Support',
    id: '5Mgu8T',
  },
  usEnterpriseSupport: {
    description: 'helpMenuDropdown.callEnterpriseSupportUS',
    defaultMessage: 'Call us (512) 975-3001, M-F 8am-6pm CST',
    id: 'GZkIZQ',
  },
  ukEnterpriseSupport: {
    description: 'helpMenuDropdown.callEnterpriseSupportUK',
    defaultMessage: 'Call Enterprise Support 44 1208 223961, (M-F 9am-5pm GMT)',
    id: 'yNZY39',
  },
  ukPlatinumSupport: {
    description: 'Phone display in help dropdown menu for uk platinum users',
    defaultMessage: 'Call Support 44 20 8629 6924, (M-F 9am-5pm GMT)',
    id: 'SrucaF',
  },
  auEnterpriseSupport: {
    description: 'helpMenuDropdown.auEnterpriseSupport',
    defaultMessage: 'Call Support 61 02 8806 1020 (M-F 8am-5:30pm AEST)',
    id: 'Fgkr5l',
  },
  nzSupportNumber: {
    description: 'helpMenuDropdown.nzSupportNumber',
    defaultMessage: 'Call Support 64 800 445 643 (M-F 10am-7:30pm NZT)',
    id: 'TRpPan',
  },
  auSupportNumber: {
    description: 'helpMenuDropdown.auSupportNumber',
    defaultMessage: 'Call Support 02 9538 7538 (M-F 8am-5:30pm AEST)',
    id: 'aHvC3b',
  },
  defaultSupportChat: {
    description: 'message for link in the help menu dropdown that opens chat support',
    defaultMessage: 'Chat with us',
    id: 'RMVSms',
  },
  frenchSupportChat: {
    description: 'helpMenuDropdown.chatWithFrenchSupport',
    defaultMessage: 'Chat with Support M-F 9am-5pm CEST',
    id: '+T0Qdh',
  },
  supportResourcesHeader: {
    description: 'helpMenuDropdown.SupportResourcesHeader',
    defaultMessage: 'Support Resources',
    id: '4PTuUw',
  },
  supportShipstationUniversity: {
    // a human readable description of the message for translators
    description: 'a link to the ShipStation University',
    defaultMessage: 'ShipStation University',
    id: 'xGVYD/',
  },
  supportGetHelp: {
    description: 'helpMenuDropdown.GetHelp',
    defaultMessage: 'Get Help',
    id: 'hryl3J',
  },
  supportCases: {
    description: 'helpMenuDropdown.supportCases',
    defaultMessage: 'My Support Cases',
    id: '/dqViQ',
  },
  hotkeys: {
    description: 'help menu dropdown hotkeys',
    defaultMessage: 'Hotkeys',
    id: 'rmNNPh',
  },
  holidaySupportMessage: {
    description: 'helpMenuDropDown.holidaySupportMessage',
    defaultMessage: 'Chat Support Temporarily Unavailable',
    id: 'RIHamQ',
  },
  emailFormSupport: {
    description: 'helpMenuDropdown.emailSupport',
    defaultMessage: 'Email Support',
    id: '7ZHHmF',
  },
  supportShopSupplies: {
    description: 'Link to an external supplies store',
    defaultMessage: 'Shop Supplies Store',
    id: 'R12w97',
  },
});

const phoneSupportMessages = defineMessages({
  US: {
    description: 'helpMenuDropdown.usV3PhoneSupport',
    defaultMessage: 'Call for Support: 512-359-3411 (M-F 9am-5pm CST)',
    id: 'xnRcgn',
  },
  AU: {
    description: 'helpMenuDropdown.auV3PhoneSupport',
    defaultMessage: 'Call for Support: (02) 4058 4690 (M-F 8am-7pm AEST)',
    id: 'jz+N++',
  },
});

const phoneTrialSupportMessages = defineMessages({
  US: {
    description: 'helpMenuDropdown.usTrialV3PhoneSupport',
    defaultMessage: 'Onboarding Support: 512-485-4266 (M-F 9am-5pm CST)',
    id: 'g0G2HK',
  },
  AU: {
    description: 'helpMenuDropdown.auTrialV3AccountManager',
    defaultMessage: 'Account Manager: (02) 6817 5771 (M-F 9am-5pm AEST)',
    id: 'Wheljg',
  },
  GB: {
    description: 'helpMenuDropdown.gbV3PhoneSupport',
    defaultMessage: 'Call for Support: +44 20 8629 6924 (M-F 9am-5pm GMT)',
    id: 'PvF1dG',
  },
  CA: {
    description: 'helpMenuDropdown.caV3PhoneSupport',
    defaultMessage: 'Call for Support: +1 (647) 493-7555 (M-F 9am-5pm CST)',
    id: '+/iT4T',
  },
});

export { messages, phoneSupportMessages, phoneTrialSupportMessages };
